import ActionType from 'actions/ActionType'

export default (state = { 0: true, 1: true, 2: true }, action) => {
  switch (action.type) {
    case ActionType.Campaign.TOGGLE_FORM_DATA_PANEL:
      return {
        ...state,
        [action.payload]: !state[action.payload],
      }
    default:
      return state
  }
}
